import { useEffect, useMemo } from "react";

import { PageName } from "analytics/events";
import { useAppLanguageStore } from "app/stores/useAppLanguageStore";
import { useCheckRoutesEffects } from "flows/Inventory/shared/hooks/useCheckRoutesEffects";
import { serializeAndTranslateCheck } from "flows/Inventory/shared/models/check/serializer";
import { useAnalytics } from "shared/hooks/useAnalytics";
import { isNullOrUndefined } from "utils/tsHelpers";

export function useFreshCheckService() {
  const appLanguage = useAppLanguageStore((state) => state.appLanguage);
  const { checkId, origin, data, loading, isInvalidParams } = useCheckRoutesEffects();
  const { sendSegmentTrackEvent } = useAnalytics();

  const taskData = useMemo(() => {
    if (!data?.getTaskById?.task) {
      return null;
    }
    return serializeAndTranslateCheck(data.getTaskById.task, appLanguage);
  }, [data, appLanguage]);

  // Track when stock check is started
  useEffect(() => {
    if (checkId && !isInvalidParams && !isNullOrUndefined(taskData?.sku)) {
      sendSegmentTrackEvent("stockCheckStarted", {
        type: "automated",
        check_id: checkId,
        product_sku: taskData.sku,
        origin: origin ?? PageName.INVENTORY_FRESH_CHECK_LIST_PAGE,
      });
    }
  }, [checkId, isInvalidParams, origin, sendSegmentTrackEvent, taskData?.sku]);

  return {
    checkId: checkId ?? null,
    origin: origin ?? PageName.INVENTORY_FRESH_CHECK_LIST_PAGE,
    shelfNumber: taskData?.shelfNumber ?? null,
    shelfLetter: taskData?.shelfLetter ?? null,
    priority: taskData?.priority ?? 0,
    sku: taskData?.sku ?? null,
    productName: taskData?.productName ?? null,
    productImageUrl: taskData?.productImageUrl ?? null,
    productCountryOfOriginName: taskData?.productCountryOfOriginName ?? null,

    loading,
    isInvalidParams,
  };
}
